import { makeStyles } from '@material-ui/core'

const clientHeaderStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.common.white,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  iconButton: {
    border: `1px solid ${theme.palette.common.white}`,
    color: theme.palette.common.white,
    marginBottom: theme.spacing(0.8),
  },
  headerContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  steps: {
    color: theme.palette.warning.main,
    fontWeight: theme.typography.fontWeightBold,
  },
  title: {
    marginBottom: theme.spacing(0.8),
  },
  subTitle: {
    marginBottom: theme.spacing(3.2),
  },
}))

export default clientHeaderStyles
